export const FETCH_FEATURED_MATCHES = 'FEATURED_MATCHES:FETCH_REQUEST';
export const FETCH_FEATURED_MATCHES_SUCCESS = 'FEATURED_MATCHES:FETCH_SUCCESS';
export const FETCH_FEATURED_MATCHES_FAILURE = 'FEATURED_MATCHES:FETCH_FAILURE';

export const FETCH_FEATURED_MATCH = 'FEATURED_MATCH:FETCH_REQUEST';
export const FETCH_FEATURED_MATCH_SUCCESS = 'FEATURED_MATCH:FETCH_SUCCESS';
export const FETCH_FEATURED_MATCH_FAILURE = 'FEATURED_MATCH:FETCH_FAILURE';

export const fetchFeaturedMatches = (indexOrSlug) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_FEATURED_MATCHES });
    try {
        const res = await mainApi.get(`v1/content/fetchfeaturedmatches/${indexOrSlug}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_FEATURED_MATCHES_FAILURE, data: data.error });
        } else {
            dispatch({ type: FETCH_FEATURED_MATCHES_SUCCESS, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_FEATURED_MATCHES_FAILURE });
    }
};

export const fetchFeaturedMatch = (index, player1Id, player2Id) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_FEATURED_MATCH, index });
    try {
        const res = await mainApi.get(`v1/player/featuredmatch?player1Id=${player1Id}&player2Id=${player2Id}`);
        const { data } = res;
        if (data.error) {
            dispatch({ type: FETCH_FEATURED_MATCH_FAILURE, index, data: data.error });
        } else {
            dispatch({ type: FETCH_FEATURED_MATCH_SUCCESS, index, data });
        }
    } catch (error) {
        dispatch({ type: FETCH_FEATURED_MATCH_FAILURE, index });
    }
};
